// extracted by mini-css-extract-plugin
module.exports = {"mainWrapper":"UserAccessManagement_mainWrapper__2j1-Z","headerBlock":"UserAccessManagement_headerBlock__3F5D5","mainIcon":"UserAccessManagement_mainIcon__38M1r"};